import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRole } from '../config/roles';
import { getCurrentUser } from '../utils/api';

export default function ProtectedRoute({ allowedRoles, children }) {
  const user = getCurrentUser();
  if (!user) return <Navigate to="/login" />;
  if (!hasRole(user.role, allowedRoles)) {
    return <Navigate to="/unauthorized" />;
  }
  return children;
}
